import styled, { css } from 'styled-components'
import { MEDIA } from 'utils'
import Card from 'src/components/forms/card'
import Button from 'src/components/button'
import { assetPrefix } from 'config/env_config'
import Calendar from 'static/icons/calendar-on.svg'
import AllServices from 'static/icons/all-services.svg'
const ICON_DIR = `${assetPrefix}/static/icons`

// Media query
const { MOBILE, MOBILE_UP, DESKTOP_UP } = MEDIA

export const SchedulingCardTitle = styled.div`
  display: flex;
  flex-direction: column;
`

export const ServiceButton = styled(Button)`
  margin: 0;
  height: 32px;
  span {
    font-size: 12px;
  }
  @media screen and ${DESKTOP_UP} {
    height: 40px;
    span {
    font-size: 16px;
  }
  }
`

export const ServiceCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  transition: all ease .2s;
  align-items: center;
  background: var(--the-white);
  color: ${props => props.disabled ? 'var(--silver-chalice)' : 'var(--the-white)'};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  padding: 8px;
  border-radius: 16px;
  border: 1px solid var(--silver);
  text-align: center;
  justify-content: space-between;
  img {
    max-width: 134px;
  }

  &:focus {
    outline: none;
  }
`

export const ButtonTextContainer = styled.div`
  width: 100%;
`

export const Container = styled.div`
  display: flex;
  justify-content: start;
  align-items: start;
  margin: 0 auto;
  gap: 24px;
  margin-top: 64px;
  margin-bottom: 64px;
  max-width: 1140px;
  @media screen and ${MOBILE} {
    flex-direction: column;
    gap: unset;
    margin: 0;
    width: 100%;
  }
`

export const Schedulings = styled(Card)`
  margin: 24px 0;
  padding: 24px;
  width: 100%;
  display: flex;
  flex-flow: column wrap;
  gap: 16px;
  @media screen and ${MOBILE} {
    padding: 16px;
  }
`

export const SchedulingsList = styled.section`
  display: flex;
  flex-flow: row wrap;
  gap: 24px;
  > div {
    flex: 1 1 340px;
  }
  @media screen and ${MOBILE} {
    flex-flow: column wrap;
    gap: 16px;
    > div {
      flex: unset;
      padding:
    }
  }
`

export const SchedulingTab = styled.section`
  margin: 0 16px;
  @media screen and ${MOBILE} {
    margin-top: 24px;
    scroll-margin-top: 62px;
  }
`

export const SchedulingTitle = styled.h2`
  color: var(--gray-2);
  font-family: var(--primary-font);
  font-style: normal;
  font-size: 16px;
  font-weight: 600;
  line-height: 19.2px;
  line-height: 27px;
  padding: 0;
  ${({ main }) => main && 'font-size: 18px;'}
`

export const SchedulingStatuses = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 8px;
`

export const Icon = styled.img`
  margin-top: 10px;
  height: 2.4rem;
  width: 2.4rem;
`

export const AgendaIcon = styled(Calendar)`
  margin: 0;
  path {
    fill: var(--cobasi-blue-light-8)
  }
  ${
    ({ active }) => !active && 'path {fill: var(--gray-5);}'
  }
`

export const AllServicesIcon = styled(AllServices)`
  margin: 0;
  path {
    fill: var(--cobasi-blue-light-8)
  }
  ${
    ({ active }) => !active && 'path {fill: var(--gray-5);}'
  }
`

export const Badge = styled.label`
  display: flex;
  gap: 4px;
  width: fit-content;
  font-family: 'Montserrat';
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  color: var(--cobasi-blue-light-8);
  align-items: center;
  justify-content: center;
  background-color: #E0F8F9;
  border-radius: 8px;
  padding: 2px 8px;

  ${({ outline }) => outline && css`
    background-color: transparent;
    border: 1px solid var(--cobasi-blue-light-8);
  `}
  ${({ big }) => big && css`
    font-size: 14px;
    padding: 6px 8px;
  `}
`

export const ScheduleText = styled.span`
  text-align: left;
  font-size: 14px;
  font-family: var(--primary-font);
  font-weight: 400;
  line-height: 19px;
  color: var(--gray-5);
  &[data-test=scheduling-empty] {
    svg {
      margin-bottom: -5px;
    }
  }
`

export const SchedulingBody = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0 15px;
  width: 100%;
`

export const SchedulingItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid var(--cobasi-blue-light);
  font-size: 12px;
  ${props => props.noBorder && 'border-bottom: none;'}

  @media screen and ${MOBILE} {
    line-height: 21px;
    font-size: ${props => props.time ? '22px' : '18px'};
  }
`

export const SchedulingIcon = styled.div`
  margin-right: 10px;
  background-color: var(--apricot-darken);
  border-radius: 100%;
  display: flex;
  width: 40px;
  height: 40px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: #FFF2EE;
  margin-right: 16px;
  img {
    height: 40px;
  }
`

export const SchedulingEditTooltip = styled.div`
  position: absolute;
  background: #6D6D6D !important;
  color: #fff !important;
  padding: 7px 10px;
  font-size: 11px;
  font-family: var(--secondary-font);
  right: 0;
  top: 36px;
  z-index: 1000;
  width: 233px;
  border-radius: 2px;
  display: none;
  min-height: 50px;
  z-index: 1;

  @media screen and ${MOBILE} {
    display: flex !important;
    width: calc(100% - 30px);
    top: auto;
    right: 15px;
    bottom: -55px;
    align-items: baseline;
    font-size: 12px;
    justify-content: space-between;
  }

  &:before {
    content: '';
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 10px solid #6D6D6D;
    z-index: 1001;
    top: -10px;
    right: 20px;
    position: absolute;
  }
`

export const SchedulingReviewLink = styled.a`
  display: block;
  margin: 0 0 15px 0;
  padding: 5px 0;
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--cobasi-blue);
  background-color: var(--apricot-light);
  border: 1px solid var(--cobasi-blue);
  border-radius: 10px;
  text-align: center;
  text-decoration: none;
`

export const SeeMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  ${props => props.disabled && 'pointer-events: none;'}
`

export const SeeMoreIcon = styled.img`
  content: url('${ICON_DIR}/service-see-more.svg');
  width: 20px;
`

export const LastSchedulingsWrapper = styled.div`
  margin: 0 16px;
  margin-top: 16px;
`

export const ServicesContainer = styled.section`
  width: 100%;
  @media screen and ${MOBILE} {
    width: auto;
    margin: 16px;
    margin-top: 20px;
    scroll-margin-top: 62px;
  }
`

export const PageTitleContainer = styled.section`
  position: relative;
  max-width: 637px;
  padding: 16px 0;
  margin-bottom: 8px;
  > div {
    font-family: var(--primary-font);
    font-size: 18px;
    margin: initial;
  }

  @media screen and ${MOBILE} {
    padding-top: 8px;
    max-width: 100%;
    position: relative;
    display: flex;

    > div {
      max-width: inherit;
      font-size: 18px;
    }
  }
`

export const MobilePageTitleContainer = styled.section`
  position: relative;
  display: flex;

  > div {
    max-width: inherit;
    font-size: 1.6rem;
  }

  @media screen and ${MOBILE_UP} {
    display: none !important;
  }
`

export const PlaceIcon = styled.img`
  content: url('${ICON_DIR}/service-place.svg');
  position: absolute;
  top: -30px;
  right: -5px;
  height: 145px;

  @media screen and ${MOBILE} {
    position: relative;
    height: 103px;
    right: 0;
    top:0;
  }
`

export const Title = styled.div`
  font-family: var(--primary-font);
  font-weight: bold;
  color: var(--cobasi-blue);
  font-size: 25px;

  @media screen and ${MOBILE} {
    font-size: 25px;
    line-height: 28px;
  }
`

export const Text = styled.div`
  font-family: var(--primary-font);
  font-size: 20px;
  font-weight: 600;
  color: var(--gray-2);

  @media screen and ${MOBILE} {
    font-size: 16px;
    line-height: 26px;
    max-width: 220px;
  }
`

export const ServiceItemsContainer = styled.section`
  max-width: 760px;
  display: flex;
  flex-flow: row wrap;
  gap: 14.67px;
  @media screen and ${MOBILE} {
    width: 320px;
    margin: 0 auto;
    gap: 16px;
  }
`

export const ButtonSize = styled.div`
  width: 150px;
  height: 250px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media screen and ${DESKTOP_UP} {
    width: 177px;
    height: 270px;
  }
`

export const ServiceName = styled.div`
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;
  margin-bottom: 4px;
  color: var(--gray-4);
  @media screen and ${DESKTOP_UP} {
    font-size: 16px;
  }
`

export const BannerPlaceholder = styled.div`
  position: relative ;
  z-index: 2;
  width: 326px;
  height: 156px;
  margin: 16px auto 0 auto;
  background-image: url(${assetPrefix + '/static/images/campaigns/326x156_anniversary.gif'});
  background-size: cover;
  border-radius: 2.4rem;

  @media screen and ${MOBILE_UP} {
    margin: 0;
  }

  @media screen and ${DESKTOP_UP} {
    background-image: url(${assetPrefix + '/static/images/campaigns/662x140_anniversary.gif'});
    width: 662px;
    height: 140px;
  }

`

export const ServiceFlag = styled.span`
  background: #19F4FF;
  border-radius: 4px;
  font: normal normal bold 12px/16px var(--secondary-font);
  color: #022222;
  padding: 2px 8px;
`

export const ServiceDescription = styled.div`
  font-family: 'Montserrat';
  padding-right: 0px;
  color: var(--gray-5);
  font-size: 12px;
  line-height: 19px;
  font-weight: 400;
  margin-bottom: 8px;
`

export const SessionTitle = styled.span`
  font-size: 20px;
  font-weight: 600;
  font-family: var(--primary-font);
  color: black;
  padding-left: 10px;
  line-height: 30px;
  display: flex;
  align-items: center;

  @media screen and ${MOBILE} {
    font-size: 22px;
  }
`

export const ServicesIcon = styled.img`
  height: 29px;
  width: 29px;
  content: url('${ICON_DIR}/service-check.svg');
`

export const Label = styled.div`
  height: 60px;
  position: absolute;
  right: -10px;
  bottom: -15px;
  z-index: 2;
  ${props => props.transform && `transform: ${props.transform};`}
`

export const BrMobile = styled.br`
  display: none !important;
  @media screen and ${MOBILE} {
    display: block;
  }
`

export const SchedulingStatus = styled.div`
  display: flex;
  justify-content: center;
  padding: 8px 0;
  border-bottom: 2px solid ${props => props.color ? props.color : '#ccc'} !important;

  span {
    ${props => props.color && `color: ${props.color} !important;`}
  }
  margin: 0 -15px 0 -15px;
`

export const SchedulingStatusIcon = styled.img`
  margin-right: 5px;
`

export const ModalTitle = styled.span`
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  color: var(--gray-2);
`
export const PetAnjoInfo = styled.div`
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  color: var(--gray-5);
  word-break: break-word;
  line-height: 2.3rem;
  margin-top: 16px;
  a {
    color: var(--cobasi-blue-light-8);
    text-decoration: inherit;
  }

  button {
    font-family: 'Montserrat';
    font-size: 14px;
    font-weight: 400;
    color: var(--cobasi-blue-light-8);
    text-decoration: inherit;
    border: none;
    background-color: transparent;
    cursor: pointer;
  }

  svg {
    path {
      fill: var(--cobasi-blue-light-8);
    }
  }

  b {
    font-weight: 600;
  }
`
export const BannerContainer = styled.div`
  margin: 0 auto;
`

export const LoadMore = styled.button`
  color: ${props => props.disabled ? '--var(--gray-9)' : 'var(--cobasi-blue-light-8)'};
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: normal;
  padding: 13px 16px;
`

export const WrapperButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 24px 0px;
`

export const PaginationCount = styled.p`
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 23.2px;
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 24px 0px;
`
